module.exports = __webpack_public_path__ + "public/eye-open.png";